import CallSummaryWithProvider from './CallSummaryWithProvider';
import CopilotCallSummary from './CopilotCallSummary';
import { gate } from 'hub-http/gates';
import { jsx as _jsx } from "react/jsx-runtime";
const CALLING_COPILOT_PREVIEW = gate('Calling:Rep:CopilotPreviewSummaries');
const CallSummary = ({
  callId,
  canEdit,
  engagementId,
  handleEngagementDataUpdated,
  initialCallSummary,
  initialNextBestActions,
  initialCallSummaryExecutionId,
  initialLastUpdatedAtTimestamp,
  initialLastUpdatedByUserId,
  isTranscriptEmpty,
  isTranscriptScheduled,
  style,
  usageTracker,
  gates,
  shouldShowNextBestActions = true
}) => {
  const isUngatedToCopilotPreview = !!gates && gates.includes(CALLING_COPILOT_PREVIEW);
  if (isUngatedToCopilotPreview) {
    return /*#__PURE__*/_jsx(CopilotCallSummary, {
      usageTracker: usageTracker,
      callId: callId
    });
  } else {
    return /*#__PURE__*/_jsx(CallSummaryWithProvider, {
      callId: callId,
      initialCallSummary: initialCallSummary,
      initialCallSummaryExecutionId: initialCallSummaryExecutionId,
      canEdit: canEdit,
      isTranscriptEmpty: isTranscriptEmpty,
      isTranscriptScheduled: isTranscriptScheduled,
      usageTracker: usageTracker,
      initialLastUpdatedAtTimestamp: initialLastUpdatedAtTimestamp,
      initialLastUpdatedByUserId: initialLastUpdatedByUserId,
      gates: gates,
      initialNextBestActions: initialNextBestActions,
      style: style,
      engagementId: engagementId,
      handleEngagementDataUpdated: handleEngagementDataUpdated,
      shouldShowNextBestActions: shouldShowNextBestActions
    });
  }
};
export default CallSummary;